(() => {
  function shareThis() {
    const insightHero = document.querySelector('#insight-hero');
    if (!insightHero) return;

    const mediaQuery = window.matchMedia('(min-width: 640px)');
    const heroImages = insightHero.querySelectorAll('.insight-hero-image');
    const shareButton = document.querySelector('#share-this-button');
    const shareMenus = insightHero.querySelectorAll('.share-menu');

    let isDesktop = mediaQuery.matches;
    let heroImage = isDesktop ? heroImages[0] : heroImages[1];
    let shareMenu = isDesktop ? shareMenus[0] : shareMenus[1];

    function closeShareMenus() {
      shareButton.classList.remove('is-open');
      heroImage.classList.remove('is-open');
      insightHero.classList.remove('share-is-open');
      shareMenus[0].setAttribute('aria-hidden', true);
      shareMenus[1].setAttribute('aria-hidden', true);
    }

    function handleBreakpointChange(event) {
      isDesktop = event.matches;
      heroImage = isDesktop ? heroImages[0] : heroImages[1];
      shareMenu = isDesktop ? shareMenus[0] : shareMenus[1];
      closeShareMenus();
    }

    mediaQuery.addEventListener('change', handleBreakpointChange);

    function toggleShareMenu() {
      const menuOpen = shareMenu.getAttribute('aria-hidden') === 'false';

      if (menuOpen) {
        shareButton.classList.remove('is-open');
        heroImage.classList.remove('is-open');
        insightHero.classList.remove('share-is-open');
        shareMenu.setAttribute('aria-hidden', true);
      } else {
        shareButton.classList.add('is-open');
        heroImage.classList.add('is-open');
        insightHero.classList.add('share-is-open');
        shareMenu.setAttribute('aria-hidden', false);
        if (!isDesktop) {
          heroImage.scrollIntoView();
        }
      }
    }

    shareButton.addEventListener('click', toggleShareMenu);
  }

  function init() {
    shareThis();
  }
  document.addEventListener('DOMContentLoaded', init, false);
})();
